import React, {  useMemo,useRef, useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next" 
import { useNavigate } from 'react-router-dom';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3'
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { es } from 'date-fns/locale';
import { DEFAULTCOLOR,ENDPOINT,DEFAULTTYPESOFTAX } from "constants/variables";
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button'; 
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 
import IconButton from '@mui/material/IconButton'; 
import MenuItem  from "@mui/material/MenuItem";  
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Textarea from '@mui/joy/Textarea';
import TextField from '@mui/material/TextField'; 
import "css/generalSettings.css";
import "css/empChips.css";
import "css/employeeHeader.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { NumericFormat } from 'components/utils/NumericFormat';
import ArticleCreateOrEditTypesOfSize from "pages/articles/articleEditOrCreate/ArticleNewTypeOfSize";
import TableSortingTypesOfSizes from "pages/articles/articleEditOrCreate/SortingTablesTypeOfSize";
import ArticleCreateOrEditColor from "pages/articles/articleEditOrCreate/ArticleNewColor";
import TableSortingColors from "pages/articles/articleEditOrCreate/SortingTablesColors";
import ArticleImageCreateOrEditArticleImage from "pages/articles/articleEditOrCreate/ArticleNewImage";
import TableSortingArticleImages from "pages/articles/articleEditOrCreate/SortingTablesPhotos";
import TableSortingStoresNumSeriales from "pages/articles/articleEditOrCreate/SortingTablesStoresNumSerial";
import TableSortingStoresPrices from "pages/articles/articleEditOrCreate/SortingTablesStoresPrice";
import ArticleCreateOrEditNumSerial from "pages/articles/articleEditOrCreate/ArticleNewNumSerial";
import PropTypes from 'prop-types';

const initialStateArticle = {
  id: "",
  titlees: "",
  titleen: "",
  subtitlees: "",
  subtitleen: "",
  owncode: "",
  codean: "",
  barcode: "",
  accountingcode:"",
  location: "",
  marca: "",
  model: "",
  createdate: "",
  applytypesofsize: false,
  applycolor: false,
  applynumserial: false,
  isnewpiece: true,
  modifystock:false,   
  minimumstock:0,
  maximumstock:0,
  actualstock:0,
  averagepurchaseprice:0,  
  lastpurchaseprice:0,
  datelastpurchaseprice: "",
  comments: "",
  salesunits_id:1,
  salesunits_namees: "",
  salesunits_nameen: "",
  salesunits_unitbase:0,  
  salesunits_quantityonbaseunit:0,  
  salesunits_symbol: "",
  department_id:0,
  department_code: "",
  department_namees: "",
  department_nameen: "",
  section_id:0,
  section_code: "",
  section_namees: "",
  section_nameen: "",
  subsection_id:0,
  subsection_code: "",
  subsection_namees: "",
  subsection_nameen: "",
  typesoftax_id:1,
  typesoftax_namees: "",
  typesoftax_nameen: "",
  typesoftax_tax:0,
  typesoftax_taxinclude:false,
  defaultprovider_id:0,
  defaultprovider_tradename: "",
  defaultprovider_documentid: "",
  lastprovider_id:0,
  lastprovider_tradename: "",
  lastprovider_documentid: "",
  color_id:2,
  color_code: "",
  color_namees: "",
  color_nameen: "",
  color_codehex: "",
  codeler_id:0,
  codeler_code: "",
  codeler_namees: "",
  codeler_nameen: "",
  articlesizes: [],
  articlecolors: [],
  articleimages: [],
  articlestoretypesofprices: [],
  articlestorenumseriales: []
};

const initialArticleColor = [
  {
    "id" : 0,
    "indexrowcolors":0,
    "enablecolorarticle":true,
    "color_id" : 2,
    "color_namees" : "",
    "color_nameen" : "",
    "color_codehex": ""
  }
];

const initialArticleImages = [{
  "id":0,
  "indexrowsarticleimage":0,
  "titlees":"",
  "titleen":"",
  "filename":"",
  "createdate":new Date(),
  "datafile":"",
  "type":"" 
}];

const initialStoreNumSerial = [
  {
    "id" : 0,
    "indexrowsnumseriales":0,
    "store_id" : 0,
    "store_name" : "",
    "substore_id" : 0,
    "substore_name" : "",
    "typeofsize_id" : 0,
    "typeofsize_namees" : "",
    "typeofsize_nameen" : "",
    "typeofsize_symbolsizes": "",
    "color_id" : 0,
    "color_namees" : "",
    "color_nameen" : "",
    "color_codehex": "",
    "serialnumber" : ""
  }
]; 

const initialArticlesize = [
  {
    "id" : 0,
    "indexrowypesofsizes":0,
    "enabletypesofsizearticle":true,
    "typeofsize_id" : 0,
    "typeofsize_namees" : "",
    "typeofsize_nameen" : "",
    "typeofsize_symbolsizes": ""
  }
];

const initialSalesUnitsToSelect = [{
  "id": 0,
  "namees": "",
  "nameen": ""
}]; 

const initialSubStoresToSelect= {
  "id":"",
  "name":"",
  "tradename":"",
  "store_id":""  
};

const initialTypesOfSizeToSelect = [{
  "id" : 0,
  "namees" : "",
  "nameen" : "",
  "symbolsizes":""
}];

const initStateSelectDepartment =[{
  "id" : 0,
  "code" : "",
  "namees" : "",
  "nameen" : "" 
}]

const initStateSelectSection = [{
  "id" : 0,
  "department_id":0,
  "code" : "",
  "namees" : "",
  "nameen" : "" 
}];
 
const initStateSelectGroup =[{
  "id" : 0,
  "department_id":0,
  "section_id":0,
  "code" : "",
  "namees" : "",
  "nameen" : ""
}]

const initialMarcaToSelect = [{
  "id": "",
  "marca": ""
}];

const initialModelToSelect = [{
  "id": "",
  "model": ""
}];

const initialColorToSelect= [{
  "id" : 0,
  "namees" : "",
  "nameen" : "",
  "codehex":""
}];
 
const initialDocumentIdToSelect = [{
  "id": "",
  "documentid": "",
  "tradename":""
}];

const initiaTypesOfTaxesToSelect = [{
  "id": "",
  "namees": "",
  "nameen": "",
  "tax": "",
  "taxinclude":false
}];

const initialCodeLERToSelect = [{
  "id": "",
  "code":"",
  "namees": "",
  "nameen": ""
}];

const hasMenuAccess = (roles, menuName) =>
  !!roles?.[0]?.listmenus?.some((item) => item.name === menuName);

const ArticleEditOrCreate = ({id, showModalArticlesSettings}) => {
  const {t,i18n} = useTranslation(['listDataArticles']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const [formArticle, setFormArticle] = useState(initialStateArticle);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorData, setIsLoadingErrorData] = useState(false);
  const [errorsArticle, setErrorsArticle] = useState({});
  const [valueTabs, setValueTabs] = useState("first");
  const [foundOwnCode, setFoundOwnCode ]= useState(false);
  const [foundCodeEan, setFoundCodeEan ]= useState(false);
  const [foundBarcode, setFoundBarcode ]= useState(false); 
  const [salesUnitsToSelect, setSalesUnitsToSelect]= useState(initialSalesUnitsToSelect);
  const [departmentsToSelect,setDepartmentsToSelect]= useState(initStateSelectDepartment);
  const [sectionsToSelect,setSectionsToSelect]= useState(initStateSelectSection);
  const [subsectionsToSelect,setSubsectionsToSelect]= useState(initStateSelectGroup);
  const [typesOfSizeToSelect,setTypesOfSizeToSelect]= useState(initialTypesOfSizeToSelect);
  const [typesOfTaxesToSelect, setTypesOfTaxesToSelect]= useState(initiaTypesOfTaxesToSelect); 
  const [subStoresToSelect, setSubStoresToSelect]= useState(initialSubStoresToSelect);  
  const [colorToSelect,setColorToSelect]= useState(initialColorToSelect);
  const [codeLERToSelect,setCodeLERToSelect]= useState(initialCodeLERToSelect);
 
  const [openEditNewTypesOfSize,setOpenEditNewTypesOfSize]= useState(false);
  const [openDeleteRowTypesOfSize,setOpenDeleteRowTypesOfSize]= useState(false);
  const [openEditRowTypesOfSize,setOpenEditRowTypesOfSize]= useState(false);
  const [editRowTypesOfSize,setEditRowTypesOfSize]= useState(initialArticlesize);
  const [idCodeDeleteTypesOfSize,setIdCodeDeleteTypesOfSize]=useState(DELETE_CODE);

  const [openEditNewColor,setOpenEditNewColor]= useState(false);
  const [openDeleteRowColor,setOpenDeleteRowColor]= useState(false);
  const [openEditRowColor,setOpenEditRowColor]= useState(false);
  const [editRowColor,setEditRowColor]= useState(initialArticleColor);
  const [idCodeDeleteColor,setIdCodeDeleteColor]=useState(DELETE_CODE);
  const [openEditNewStoresNumSerial,setOpenEditNewStoresNumSerial]= useState(false);
  const [openDeleteRowStoresNumSerial,setOpenDeleteRowStoresNumSerial]= useState(false);
  const [openEditRowStoresNumSerial,setOpenEditRowStoresNumSerial]= useState(false);
  const [editRowStoreNumSerial,setEditRowStoreNumSerial]= useState(initialStoreNumSerial);
  const [idCodeDeleteNumSerial,setIdCodeDeleteNumSerial]=useState(DELETE_CODE);
  const [openEditNewArticleImage,setOpenEditNewArticleImage]= useState(false);
  const [openDeleteRowArticleImage,setOpenDeleteRowArticleImage]= useState(false);
  const [openEditRowArticleImage,setOpenEditRowArticleImage]= useState(false);
  const [editRowArticleImage,setEditRowArticleImage]= useState(initialArticleImages);
  const [idCodeDeleteArticleImage,setIdCodeDeleteArticleImage]=useState(DELETE_CODE);
  const [marcaToSelect,setMarcaToSelect]= useState(initialMarcaToSelect);  
  
  const [filteredMarca, setFilteredMarca] = useState([]); // Opciones filtradas
  const [highlightedIndexMarca, setHighlightedIndexMarca] = useState(-1); // Índice de la opción resaltada 
  const [modelToSelect,setModelToSelect]= useState(initialModelToSelect);  
  const [filteredModel, setFilteredModel] = useState([]); // Opciones filtradas
  const [highlightedIndexModel, setHighlightedIndexModel] = useState(-1); // Índice de la opción resaltada 
  const [tradenameOptToSelect,setTradenameOptToSelect]= useState(initialDocumentIdToSelect);  
  const [filteredTradenamed, setFilteredTradenamed] = useState([]); // Opciones filtradas
  const [highlightedIndexTradenamed, setHighlightedIndexTradenamed] = useState(-1); // Índice de la opción resaltada 
  const ddRefMarca = useRef(null);
  const ddRefModel = useRef(null);
  const ddRefTrade = useRef(null);

  const permissions = useMemo(() => ({
    showStorePrices: hasMenuAccess(roles, 'Handle_Article_View_Stores_Prices'),
    showStorePhotos: hasMenuAccess(roles, 'Handle_Article_View_Photos'),
    showStoreSizes: hasMenuAccess(roles, 'Handle_Article_View_TypesOfSizes'),
    showStoreColors: hasMenuAccess(roles, "Handle_Article_View_Colors"),
    showStoreNumSeriales: hasMenuAccess(roles, "Handle_Article_View_NumSeriales"),
    showExtendedFilter: hasMenuAccess(roles, "Handle_Article_View_Extemded")
  }), [roles]);

  const dispatch = useDispatch();
  const navigate = useNavigate(); 
 
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalArticlesSettings) {
        setFormArticle(initialStateArticle);
        setFormArticle(formArticle => ({
          ...formArticle,
          articlestoretypesofprices : [],
          articleimages:[],
          articlesizes : [],
          articlecolors : [],
          articlestorenumseriales : [] 
        }));
        dispatch(setLoading(false));
        setIsLoadingErrorData(false);
        setErrorsArticle({});
        setValueTabs("first");
        setFoundOwnCode(false);
        setFoundCodeEan(false);
        setFoundBarcode(false);
        setSalesUnitsToSelect(initialSalesUnitsToSelect);
        setDepartmentsToSelect(initStateSelectDepartment);
        setCodeLERToSelect(initialCodeLERToSelect);
        setSectionsToSelect(initStateSelectSection);
        setSubsectionsToSelect(initStateSelectGroup);
        setTypesOfSizeToSelect(initialTypesOfSizeToSelect);
        setTypesOfTaxesToSelect(initiaTypesOfTaxesToSelect);     
        setSubStoresToSelect(initialSubStoresToSelect); 
        setColorToSelect(initialColorToSelect);   
        setOpenEditNewTypesOfSize(false);
        setOpenDeleteRowTypesOfSize(false);
        setOpenEditRowTypesOfSize(false);
        setEditRowTypesOfSize(initialArticlesize);
        setIdCodeDeleteTypesOfSize(DELETE_CODE); 
        setOpenEditNewColor(false);
        setOpenDeleteRowColor(false);
        setOpenEditRowColor(false);
        setEditRowColor(initialArticleColor);
        setIdCodeDeleteColor(DELETE_CODE);
        setOpenEditNewStoresNumSerial(false);
        setOpenDeleteRowStoresNumSerial(false);
        setOpenEditRowStoresNumSerial(false);
        setEditRowStoreNumSerial(initialStoreNumSerial);
        setIdCodeDeleteNumSerial(DELETE_CODE);
        setOpenEditNewArticleImage(false);
        setOpenDeleteRowArticleImage(false);
        setOpenEditRowArticleImage(false);
        setEditRowArticleImage(initialArticleImages);
        setIdCodeDeleteArticleImage(DELETE_CODE);
        setMarcaToSelect(initialMarcaToSelect);
        setFilteredMarca([]);
        setHighlightedIndexMarca(-1); 
        setModelToSelect(initialModelToSelect);
        setFilteredModel([]);
        setHighlightedIndexModel(-1); 
        setTradenameOptToSelect(initialDocumentIdToSelect);
        setFilteredTradenamed([]);
        setHighlightedIndexTradenamed(-1);
        navigate("/article");
      }
    },
    [ 
      setFormArticle,
      setIsLoadingErrorData,
      setErrorsArticle,
      setValueTabs,
      setFoundOwnCode,
      setFoundCodeEan,
      setFoundBarcode,
      setSalesUnitsToSelect,
      setDepartmentsToSelect,
      setSectionsToSelect,
      setSubsectionsToSelect,
      setTypesOfSizeToSelect,
      setTypesOfTaxesToSelect,  
      setSubStoresToSelect,
      setColorToSelect,     
      setOpenEditNewTypesOfSize,
      setOpenDeleteRowTypesOfSize,
      setOpenEditRowTypesOfSize,
      setEditRowTypesOfSize,
      setIdCodeDeleteTypesOfSize,
      setOpenEditNewColor,
      setOpenDeleteRowColor,
      setOpenEditRowColor,
      setEditRowColor,
      setCodeLERToSelect,
      setIdCodeDeleteColor,
      setOpenEditNewStoresNumSerial,
      setOpenDeleteRowStoresNumSerial,
      setOpenEditRowStoresNumSerial,
      setEditRowStoreNumSerial,
      setIdCodeDeleteNumSerial,
      setOpenEditNewArticleImage,
      setOpenDeleteRowArticleImage,
      setOpenEditRowArticleImage,
      setEditRowArticleImage,
      setIdCodeDeleteArticleImage,
      setMarcaToSelect,
      setFilteredMarca,
      setHighlightedIndexMarca,
      setModelToSelect,
      setFilteredModel,
      setHighlightedIndexModel,
      setTradenameOptToSelect,
      setFilteredTradenamed,
      setHighlightedIndexTradenamed,
      showModalArticlesSettings,
      DELETE_CODE,
      dispatch,
      navigate]
  );
  
  const handleCloseDataEditArticle = () => { 
    setFormArticle(initialStateArticle);
    setFormArticle(formArticle => ({
      ...formArticle,
      articlestoretypesofprices : [],
      articleimages:[],
      articlesizes : [],
      articlecolors : [],
      articlestorenumseriales : [] 
    }));
    dispatch(setLoading(false));
    setIsLoadingErrorData(false);
    setErrorsArticle({});
    setValueTabs("first");
    setFoundOwnCode(false);
    setFoundCodeEan(false);
    setFoundBarcode(false);
    setSalesUnitsToSelect(initialSalesUnitsToSelect);
    setDepartmentsToSelect(initStateSelectDepartment);
    setCodeLERToSelect(initialCodeLERToSelect);
    setSectionsToSelect(initStateSelectSection);
    setSubsectionsToSelect(initStateSelectGroup);
    setTypesOfSizeToSelect(initialTypesOfSizeToSelect);
    setTypesOfTaxesToSelect(initiaTypesOfTaxesToSelect);    
    setSubStoresToSelect(initialSubStoresToSelect); 
    setColorToSelect(initialColorToSelect);    
    setOpenEditNewTypesOfSize(false);
    setOpenDeleteRowTypesOfSize(false);
    setOpenEditRowTypesOfSize(false);
    setEditRowTypesOfSize(initialArticlesize);
    setIdCodeDeleteTypesOfSize(DELETE_CODE); 
    setOpenEditNewColor(false);
    setOpenDeleteRowColor(false);
    setOpenEditRowColor(false);
    setEditRowColor(initialArticleColor);
    setIdCodeDeleteColor(DELETE_CODE);
    setOpenEditNewStoresNumSerial(false);
    setOpenDeleteRowStoresNumSerial(false);
    setOpenEditRowStoresNumSerial(false);
    setEditRowStoreNumSerial(initialStoreNumSerial);
    setIdCodeDeleteNumSerial(DELETE_CODE);
    setOpenEditNewArticleImage(false);
    setOpenDeleteRowArticleImage(false);
    setOpenEditRowArticleImage(false);
    setEditRowArticleImage(initialArticleImages);
    setIdCodeDeleteArticleImage(DELETE_CODE);
    setMarcaToSelect(initialMarcaToSelect);
    setFilteredMarca([]);
    setHighlightedIndexMarca(-1); 
    setModelToSelect(initialModelToSelect);
    setFilteredModel([]);
    setHighlightedIndexModel(-1); 
    setTradenameOptToSelect(initialDocumentIdToSelect);
    setFilteredTradenamed([]);
    setHighlightedIndexTradenamed(-1);
    navigate("/article");
	};

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
    };
    
  // Dentro del componente
  const debouncedHandleSearchMarca = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredMarca([]);
      setHighlightedIndexMarca(-1);
      return;
    }
    const filtered = marcaToSelect
      .filter(vehicle => vehicle && vehicle.marca)
      .filter(vehicle => {
        const vehiclestoremarca= vehicle.marca.toUpperCase();
        return vehiclestoremarca.includes(upperValue);
      })
      .slice(0, 40); // limitar resultados
      setFilteredMarca(filtered);
      setHighlightedIndexMarca(0);
  }, 300);
  const handleSelectMarca = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setFormArticle(formArticle => ({
      ...formArticle,
      marca: (vehicle.marca || "") 
    }));
    setFilteredMarca([]);
    setHighlightedIndexMarca(-1);
  }; 
  const handleKeyDownMarca = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredMarca.length === 0 && formArticle.marca.trim() === "") {
        setFilteredMarca(marcaToSelect);
        setHighlightedIndexMarca(0);
      } else {
        setHighlightedIndexMarca((prevIndex) => {
          const nextIndex = prevIndex < filteredMarca.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex,ddRefMarca);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexMarca((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid,ddRefMarca);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexMarca >= 0) {
      if (highlightedIndexMarca >= 0 && highlightedIndexMarca < filteredMarca.length) {
        handleSelectMarca(filteredMarca[highlightedIndexMarca]);
      }
    } else if (event.key === "Escape") {
      const isValid = marcaToSelect.some((vehicle) => {
        if (!vehicle || !vehicle.marca) return false; 
        const normalizedVehicleMarca = vehicle.marca.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicleMarca = formArticle.marca.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicleMarca === normalizedInputVehicleMarca;
      }); 
      if (!isValid) {
        setFormArticle((formArticle) => ({
          ...formArticle,
          marca: "",
        }));
      } 
      setFilteredMarca([]);
      setHighlightedIndexMarca(-1);
    }
  }; 

  // Dentro del componente
  const debouncedHandleSearchModel = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredModel([]);
      setHighlightedIndexModel(-1);
      return;
    }
    const filtered = modelToSelect
      .filter(vehicle => vehicle && vehicle.model)
      .filter(vehicle => {
        const vehiclestoremodel = vehicle.model.toUpperCase();
        return vehiclestoremodel.includes(upperValue);
      })
      .slice(0, 40); // limitar resultados
      setFilteredModel(filtered);
      setHighlightedIndexModel(0);
  }, 300);
  const handleSelectModel = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setFormArticle(formArticle => ({
      ...formArticle,
      model: (vehicle.model || "") 
    }));
    setFilteredModel([]);
    setHighlightedIndexModel(-1);
  }; 
  const handleKeyDownModel = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredModel.length === 0 && formArticle.model.trim() === "") {
        setFilteredModel(modelToSelect);
        setHighlightedIndexModel(0);
      } else {
        setHighlightedIndexModel((prevIndex) => {
          const nextIndex = prevIndex < filteredModel.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex,ddRefModel);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexModel((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid,ddRefModel);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexModel >= 0) {
      if (highlightedIndexModel >= 0 && highlightedIndexModel < filteredModel.length) {
        handleSelectModel(filteredModel[highlightedIndexModel]);
      }
    } else if (event.key === "Escape") {
      const isValid = modelToSelect.some((vehicle) => {
        if (!vehicle || !vehicle.model) return false; 
        const normalizedVehicleModel = vehicle.model.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicleModel = formArticle.model.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicleModel === normalizedInputVehicleModel;
      }); 
      if (!isValid) {
        setFormArticle((formArticle) => ({
          ...formArticle,
          model: "",
        }));
      } 
      setFilteredModel([]);
      setHighlightedIndexModel(-1);
    }
  };

  // Dentro del componente
  const debouncedHandleSearchTradename= useDebounce((searchValue) => {
      const upperValue = searchValue.toUpperCase();
      if (upperValue.trim() === "") {
          setFilteredTradenamed([]);
          setHighlightedIndexTradenamed(-1);
      return;
      }
      const filtered = tradenameOptToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
          const tradename = store.tradename.toUpperCase();
          return tradename.includes(upperValue);
      })
      .slice(0, 30); // limitar resultados
      setFilteredTradenamed(filtered);
      setHighlightedIndexTradenamed(0);
  }, 300); 
  const handleSelectTradeName = (store) => {
      if (!store) return; // Validación adicional para evitar errores
      setFormArticle((formArticle) => ({
      ...formArticle,
      defaultprovider_id: store.id || 0,
      defaultprovider_tradename: store.tradename || "",
      defaultprovider_documentid: store.documentid || formArticle.defaultprovider_documentid,
      
      }));
      setFilteredTradenamed([]);
      setHighlightedIndexTradenamed(-1);
  }; 
  const handleKeyDownTradename = (event) => {
      if (event.key === "ArrowDown") {
      if (filteredTradenamed.length === 0 && formArticle.defaultprovider_tradename.trim() === "") {
          setFilteredTradenamed(tradenameOptToSelect);
          setHighlightedIndexTradenamed(0);
      } else {
          setHighlightedIndexTradenamed((prevIndex) => {
          const nextIndex = prevIndex < filteredTradenamed.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex,ddRefTrade);
          return nextIndex;
          });
      }
      } else if (event.key === "ArrowUp") {
      setHighlightedIndexTradenamed((prevIndex) => {
          const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
          // Desplaza al elemento anterior
          scrollToElement(prevIndexValid,ddRefTrade);
          return prevIndexValid;
      });
      } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamed >= 0) {
      if (highlightedIndexTradenamed >= 0 && highlightedIndexTradenamed < filteredTradenamed.length) {
          handleSelectTradeName(filteredTradenamed[highlightedIndexTradenamed]);
      }
      } else if (event.key === "Escape") {
      const isValid = tradenameOptToSelect.some((store) => {
          if (!store || !store.tradename) return false; 
          const normalizedTradeName = store.tradename.toUpperCase();
          const normalizedInputTradeName = formArticle.defaultprovider_tradename.toUpperCase();
          return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
          setFormArticle((formArticle) => ({
            ...formArticle,
            defaultprovider_id: 0,
            defaultprovider_tradename: "",
            defaultprovider_documentid:""
          }));
      } 
      setFilteredTradenamed([]);
      setHighlightedIndexTradenamed(-1);
      }
  }; 

  // Función para desplazar el contenedor
  const scrollToElement = (index, ref) => {
    const dropdown = ref?.current;
    const item = dropdown?.children?.[index];
    if (item) item.scrollIntoView({ behavior: "smooth", block: "nearest" });
  };


  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setHighlightedIndexMarca(-1); 
      setFilteredMarca([]); 
      setHighlightedIndexModel(-1); 
      setFilteredModel([]); 
      setHighlightedIndexTradenamed(-1); 
      setFilteredTradenamed([]); 
    }
  }, []); 

  const copyData = (e) => {
    if (formArticle.codeler_id!==undefined && formArticle.codeler_id!=="" && formArticle.codeler_id!=="0" && formArticle.codeler_id!==0){
      let idx=codeLERToSelect.find((key)=>(Number(key.id)===Number(formArticle.codeler_id)));
      setFormArticle(formArticle => ({
        ...formArticle,
        titlees:idx.namees,
        titleen: idx.nameen
    }));
     
    } 
  };

   const handleBlurDataEditArticleCodeLer = (e) => {
    handleChangeDataEditArticle(e);
    setErrorsArticle(validateFormArticle());
  };

  const handleChangeDataEditArticleCodeLER = (event) => {
     setFormArticle(formArticle => ({
        ...formArticle,
        codeler_id:event.target.value
    }));
  };

  const handleBlurDataEditArticle = (e) => {
    handleChangeDataEditArticle(e);
    setErrorsArticle(validateFormArticle());
  };

  const handleChangeDataEditArticle = (e) => {
    const { name, value } = e.target;
    setFormArticle(formArticle => ({
      ...formArticle,
      [name]: value,
      titleen: formArticle.titlees,
      subtitleen: formArticle.subtitlees
    }));
  };

  const handleChangeApplyTypesOfSize = () => {
    if (formArticle.articlestorenumseriales.length>0){
      dispatch(warningErrorAction(t('Text_Error_ExistNumSerial')));
    }else {
      if (formArticle.articlesizes!==undefined && formArticle.articlesizes.length===0){
        setFormArticle(formArticle => ({
          ...formArticle,
          applytypesofsize: !formArticle.applytypesofsize
        }));
      }else{
        setFormArticle(formArticle => ({
          ...formArticle,
          applytypesofsize: true
        }));
        dispatch(warningErrorAction(t('Text_ExistTypesOfSizes')));
      }
    }
  };

  const handleChangeApplyColor = () => {
    if (formArticle.articlestorenumseriales.length>0){
      dispatch(warningErrorAction(t('Text_Error_ExistNumSerial')));
      }else {
      if (formArticle.articlecolors!==undefined && formArticle.articlecolors.length===0){
        setFormArticle(formArticle => ({
          ...formArticle,
          applycolor: !formArticle.applycolor
        }));
      }else{
        setFormArticle(formArticle => ({
          ...formArticle,
          applycolor: true
        }));
        dispatch(warningErrorAction(t('Text_ExistColors')));
      }
    }  
  };

  const handleChangeApplyNumSerial = () => {
    
    if (formArticle.articlestorenumseriales===undefined || formArticle.articlestorenumseriales.length===0){
      setFormArticle(formArticle => ({
        ...formArticle,
        applynumserial: !formArticle.applynumserial
      }));
    }else{ 
      setFormArticle(formArticle => ({
        ...formArticle,
        applynumserial: true
      }));
      dispatch(warningErrorAction(t('Text_ExistNumSeriales')));    
    }
  };

  const handleChangeApplyNewPiece = () => {
    setFormArticle(formArticle => ({
      ...formArticle,
      isnewpiece: !formArticle.isnewpiece
    }));
       
  };

  const handleBlurSelectSalesUnits = (e) => {
    handleChangeSelectSalesUnits(e);
    setErrorsArticle(validateFormArticle());
  };

  const handleChangeSelectSalesUnits = (event) => {
    setFormArticle(formArticle => ({
        ...formArticle,
        salesunits_id:event.target.value
    }));
  };

  const handleBlurSelectDepartment = (e) => {
    handleChangeSelectDepartment(e);
    setErrorsArticle(validateFormArticle());
  };

  const handleChangeSelectDepartment = (event) => {
    setFormArticle(formArticle => ({
      ...formArticle,
      department_id:event.target.value,
      section_id : 0,
      subsection_id : 0 
    }));
  }; 

  const handleBlurSelectSection = (e) => {
    handleChangeSelectSection(e);
    setErrorsArticle(validateFormArticle());
  };

  const handleChangeSelectSection = (event) => {
    if (event.target.value!==""){
      let idx=sectionsToSelect.findIndex(((item) => item.id === Number(event.target.value)));
      setFormArticle(formArticle => ({
        ...formArticle,
        department_id:sectionsToSelect[idx].department_id ,
        section_id:sectionsToSelect[idx].id,
        subsection_id : 0
      }));
    }else{
      setFormArticle(formArticle => ({
        ...formArticle,
        section_id : 0,
        subsection_id : 0
      }));
    }
  }; 

  const handleBlurSelectGroup = (e) => {
    handleChangeSelectGroup(e);
    setErrorsArticle(validateFormArticle());
  };

  const handleChangeSelectGroup = (event) => {
     if (event.target.value!==""){
      let idx=subsectionsToSelect.findIndex(((item) => item.id === Number(event.target.value)));
      setFormArticle(formArticle => ({
        ...formArticle,
        department_id:subsectionsToSelect[idx].department_id ,
        section_id:subsectionsToSelect[idx].section_id,
        subsection_id : subsectionsToSelect[idx].id
      }));
    }else{
      setFormArticle(formArticle => ({
        ...formArticle,
        subsection_id : 0
      }));
    }
  }; 
 
  const handleBlurSelectColor = (e) => {
    handleChangeSelectColor(e);
     setErrorsArticle(validateFormArticle());
  };

  const handleChangeSelectColor = (event) => {
    let colorHex="#FFFFFF";
    if (event.target.value!==""){
      colorHex=colorToSelect.find((key=>key.id===Number(event.target.value))).codehex;
    }

    setFormArticle(formArticle => ({
        ...formArticle,
        color_id:event.target.value,
        color_codehex:colorHex
    }));
  };

  const handleChangeSelectTypesOfTax = (event) => {
   
    let valor= event.target.value;
    let idx=typesOfTaxesToSelect.findIndex(((item) => item.id === Number(valor)));
    setFormArticle(formArticle => ({
      ...formArticle,
      typesoftax_id:valor,
      typesoftax_tax:typesOfTaxesToSelect[idx].tax,
      typesoftax_taxinclude:typesOfTaxesToSelect[idx].taxinclude
    }));
  };

  const handleBlurSelectTypesOfTax= (e) => {
    handleChangeSelectTypesOfTax(e);
    setErrorsArticle(validateFormArticle());
  };
 

  const handleChangeModifystock = () => {
    setFormArticle(formArticle => ({
      ...formArticle,
      modifystock: !formArticle.modifystock
    }));
  };

  const handleChangeDataEditNumer = (e) => {
    const { name, value } = e.target;
    let newValue=value!==null?Number((value.toLocaleString()).replaceAll(",","")):0;
    setFormArticle(formArticle => ({
      ...formArticle,
      [name]: newValue,
    }));
  };

  const handleBlurDataEditNumber = (e) => {
    handleChangeDataEditNumer(e);
    setErrorsArticle(validateFormArticle());
  };
  const withValueCap = (inputObj) => {
    const { value } = inputObj;
    if (value <= 10000000) return true;
    return false;
  };

  const handleSubmitDataEditArticle = () => {
    const errorsExistArticle = validateFormArticle(); 
    setErrorsArticle(errorsExistArticle);
    if ((Object.keys(errorsExistArticle).length === 0) && formArticle.titlees!=='' 
          && formArticle.salesunits_id!==undefined && formArticle.salesunits_id!==null 
          && formArticle.salesunits_id!=='' && formArticle.salesunits_id!=='0' && formArticle.salesunits_id!==0
          && formArticle.subsection_id!==undefined && formArticle.subsection_id!==null 
          && formArticle.subsection_id!=='' && formArticle.subsection_id!=='0' && formArticle.subsection_id!==0 ) {
      handleCloseDataEditArticle();
      const fetchData = async () => {
      try {
        const getData = id !== "0"
          ? await helpHttp().put(ENDPOINT, `articles/updatearticle`, token, formArticle)
          : await helpHttp().post(ENDPOINT, `articles/savearticle`, token, formArticle);
          if (getData.status === "OK") {
            dispatch(successErrorAction(t('Text_SaveData')));
          }
        } catch (error) {
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }  
      }; 
      fetchData();  
    } else {
      if (errorsExistArticle.titlees) {
        dispatch(warningErrorAction(t(errorsExistArticle.titlees)));
      } else if (errorsExistArticle.titleen) {
        dispatch(warningErrorAction(t(errorsExistArticle.titleen)));
      } else if (errorsExistArticle.subtitlees) {
        dispatch(warningErrorAction(t(errorsExistArticle.subtitlees)));
      } else if (errorsExistArticle.subtitleen) {
        dispatch(warningErrorAction(t(errorsExistArticle.subtitleen)));
      } else if (errorsExistArticle.owncode) {
        dispatch(warningErrorAction(t(errorsExistArticle.owncode)));
      } else if (errorsExistArticle.codean) {
        dispatch(warningErrorAction(t(errorsExistArticle.codean)));
      } else if (errorsExistArticle.barcode) {
        dispatch(warningErrorAction(t(errorsExistArticle.barcode)));
      } else if (errorsExistArticle.accountingcode) {
        dispatch(warningErrorAction(t(errorsExistArticle.accountingcode)));
      } else if (errorsExistArticle.location) {
        dispatch(warningErrorAction(t(errorsExistArticle.location)));
      } else if (errorsExistArticle.marca) {
        dispatch(warningErrorAction(t(errorsExistArticle.marca)));
      } else if (errorsExistArticle.model) {
        dispatch(warningErrorAction(t(errorsExistArticle.model)));
      } else if (errorsExistArticle.comments) {
        dispatch(warningErrorAction(t(errorsExistArticle.comments)));
      } else if (errorsExistArticle.salesunits_id) {
        dispatch(warningErrorAction(t(errorsExistArticle.salesunits_id)));
      } else if (errorsExistArticle.subsection_id) {
        dispatch(warningErrorAction(t(errorsExistArticle.subsection_id)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }  
    }
  };
 
  const validateFormArticle = () => {
    let errorsArticle = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    if (regexInvalidCharacters.test(formArticle.titlees)) {
      errorsArticle.titlees = 'Text_TextNoValid';
    } else{
      if (!formArticle.titlees || formArticle.titlees==="") {
        errorsArticle.titlees = 'Text_FieldTitlesRequired'; 
      }
    }
    if (regexInvalidCharacters.test(formArticle.titleen)) {
      errorsArticle.titleen = 'Text_TextNoValid';
    } else{
    if (!formArticle.titleen || formArticle.titleen==="") {
        errorsArticle.titleen = 'Text_FieldTitlenRequired';
      }
    }
    if (regexInvalidCharacters.test(formArticle.subtitlees)) {
      errorsArticle.subtitlees = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formArticle.subtitleen)) {
      errorsArticle.subtitleen = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formArticle.owncode)) {
      errorsArticle.owncode = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formArticle.codean)) {
      errorsArticle.codean = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formArticle.barcode)) {
      errorsArticle.barcode = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formArticle.accountingcode)) {
      errorsArticle.accountingcode = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formArticle.location)) {
      errorsArticle.location = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formArticle.marca)) {
      errorsArticle.marca = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formArticle.model)) {
      errorsArticle.model = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(formArticle.comments)) {
      errorsArticle.comments = 'Text_TextNoValid';
    }  
    if (foundOwnCode && formArticle.owncode!==""){
      errorsArticle.owncode='Text_FielOwnCodeExist';
    }
    if (foundCodeEan && formArticle.codean!==""){
      errorsArticle.codean='Text_FielCodeEanExist';
    }
    if (foundBarcode && formArticle.barcode!==""){
      errorsArticle.barcode='Text_FielBarcodeExist';
    } 
    if (formArticle.salesunits_id===undefined || formArticle.salesunits_id===null ||formArticle.salesunits_id==="" || formArticle.salesunits_id===0 || formArticle.salesunits_id==="0") {
      errorsArticle.language_id = 'Text_FieldSalesUnitsRequired';
    }
    if (formArticle.subsection_id===undefined || formArticle.subsection_id===null ||formArticle.subsection_id==="" || formArticle.undersubsection_id==="0" || formArticle.subsection_id===0) {
      errorsArticle.subsection_id = 'Text_FieldGroupisRequired';
    }   
    if (formArticle.codean===""){
      if (formArticle.owncode===""){
        if (formArticle.barcode===""){
          errorsArticle.codean='Text_Article_Code_Required';
        } 
      }    
    }
    return errorsArticle;
  };
 
  const handleChangeValueTabs = (event,newValueTabs) => {
    setValueTabs(newValueTabs);
  };
  
  const handleCancelDeleteRowColors = () => {
    setIdCodeDeleteColor(DELETE_CODE);
    setOpenDeleteRowColor(false);
  };

  const handleCancelDeleteRowNumSeriales = () => {
    setIdCodeDeleteNumSerial(DELETE_CODE);
    setOpenDeleteRowStoresNumSerial(false);
  };

  const handleCancelDeleteRowArticleImage = () => {
    setIdCodeDeleteArticleImage(DELETE_CODE);
    setOpenDeleteRowArticleImage(false);
  };
  
  const handleChangeDeleteRowTypesOfSizes = (e) => {
    const value  = e.target.value;
    setIdCodeDeleteTypesOfSize(value);
  };

  const handleChangeDeleteRowColors = (e) => {
    const value  = e.target.value;
    setIdCodeDeleteColor(value);
  };

  const handleChangeDeleteRowNumSeriales = (e) => {
    const value  = e.target.value;
    setIdCodeDeleteNumSerial(value);
  };

   const handleCancelDeleteRowTypesOfSizes = () => {
    setIdCodeDeleteTypesOfSize(DELETE_CODE);
    setOpenDeleteRowTypesOfSize(false);
  };
 

  const handleChangeDeleteRowArticleImage = (e) => {
    const value  = e.target.value;
    setIdCodeDeleteArticleImage(value);
  };
 
  const handleCloseDeleteRowTypesOfSizes = (e) => {
    e.preventDefault();
    if (idCodeDeleteTypesOfSize!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      let indexDelete=formArticle.articlesizes.findIndex(((item) => item.indexrowypesofsizes === editRowTypesOfSize.indexrowypesofsizes));
      if ( indexDelete !== -1 ) {
        formArticle.articlesizes.splice( indexDelete, 1 );
      }
      setFormArticle(formArticle => ({
        ...formArticle,
      }))
      setIdCodeDeleteTypesOfSize(DELETE_CODE);
      setOpenDeleteRowTypesOfSize(false);
    }
  };
  
  const handleCloseDeleteRowColors = (e) => {
    e.preventDefault();
    if (idCodeDeleteColor!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      let indexDelete=formArticle.articlecolors.findIndex(((item) => item.indexrowcolors === editRowColor.indexrowcolors));
      if ( indexDelete !== -1 ) {
        formArticle.articlecolors.splice( indexDelete, 1 );
      }
      setFormArticle(formArticle => ({
        ...formArticle,
      }))
      setIdCodeDeleteColor(DELETE_CODE);
      setOpenDeleteRowColor(false);
    }
  };

  const handleCloseDeleteRowNumSeriales = (e) => {
    e.preventDefault();
    if (idCodeDeleteNumSerial!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      
      let indexDelete=formArticle.articlestorenumseriales.findIndex(((item) => item.indexrowsnumseriales === editRowStoreNumSerial.indexrowsnumseriales));
      if ( indexDelete !== -1 ) {
        formArticle.articlestorenumseriales.splice( indexDelete, 1 );
      }
      setFormArticle(formArticle => ({
        ...formArticle,
      }))
      setIdCodeDeleteNumSerial(DELETE_CODE);
      setOpenDeleteRowStoresNumSerial(false);
    }
  };

  const handleCloseDeleteRowArticleImage = (e) => {
    e.preventDefault();
    if (idCodeDeleteArticleImage!==DELETE_CODE){
      dispatch(warningErrorAction(t('Text_InvalidCode')));
    } else {
      
      let indexDelete=formArticle.articleimages.findIndex(((item) => item.indexrowsarticleimage === editRowArticleImage.indexrowsarticleimage));
      if ( indexDelete !== -1 ) {
        formArticle.articleimages.splice( indexDelete, 1 );
      }
      setFormArticle(formArticle => ({
        ...formArticle,
      }))
      setIdCodeDeleteArticleImage(DELETE_CODE);
      setOpenDeleteRowArticleImage(false);
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true;

    const fetchDataTypeOfUnits = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, i18n.language==='es'
          ?`typesofunits/getsimplesalesunitsbynamees`
          :`typesofunits/getsimplesalesunitsbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setSalesUnitsToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchDataDepartment = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, i18n.language==='es'
          ?`department/simpledepartmentsbynamees`
          :`department/simpledepartmentsbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setDepartmentsToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchDataTypesOfSize = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, i18n.language==='es'
          ?`typesofsizes/typesofsizeorderbynamees`
          :`typesofsizes/typesofsizeorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setTypesOfSizeToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchDataTypesOfTax = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, i18n.language==='es'
          ?`typesoftaxes/typesoftaxorderbynamees`
          :`typesoftaxes/typesoftaxorderbynameem`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setTypesOfTaxesToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchDataColor = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT, i18n.language==='es'
          ?`color/colorsorderbynamees`
          :`color/colorsorderbynameen`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setColorToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchDataCodeLER = async () => {
      try {
        const getData =   await helpHttp().get(ENDPOINT, `articles/codelersorderbycode`, token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setCodeLERToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    const fetchDataSubStores = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`articles/getsubstoresbyname/`, token,"-1");
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setSubStoresToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    }; 
    if (showModalArticlesSettings && formArticle.id!==null ){
      if (permissions.showExtendedFilter ){
        fetchDataTypesOfSize(); 
        fetchDataSubStores();
      }
      fetchDataColor();
      fetchDataTypeOfUnits(); 
      fetchDataDepartment();
      fetchDataTypesOfTax(); 
      fetchDataCodeLER();
    }
    return () => { isMounted = false };

  }, [t,token,dispatch,i18n,roles,formArticle.id,showModalArticlesSettings,permissions.showExtendedFilter]);
 
  useEffect(() => {
    let isMounted = true;
    const fetchDataSectionsByDepartment = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, i18n.language==='es'
          ?`section/getsectiondepartmentorderbynamees/`
          :`section/getsectiondepartmentorderbynamees/`, token,
          formArticle.department_id?formArticle.department_id:0);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setSectionsToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showModalArticlesSettings ){
      fetchDataSectionsByDepartment(); 
    }
    return () => { isMounted = false }; 
  }, [t,token,dispatch,i18n,roles,formArticle.id,formArticle.department_id,showModalArticlesSettings]);
  
  useEffect(() => {
    let isMounted = true;
      const fetchDataSectionsByDepartment = async () => {
      try {
        const getData = await helpHttp().get5(ENDPOINT, i18n.language==='es'
          ?`subsection/getsubsectionsectionorderbynamees`
          :`subsection/getsubsectionsectionorderbynameen`, token,
          formArticle.department_id?formArticle.department_id:0,
          formArticle.section_id?formArticle.section_id:0
        ); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setSubsectionsToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showModalArticlesSettings){
       fetchDataSectionsByDepartment(); 
    }
    return () => { isMounted = false }; 
  }, [t,token,dispatch,i18n,roles,formArticle.id,formArticle.department_id,formArticle.section_id,showModalArticlesSettings]);
  
  useEffect(() => {
    let isMounted = true;
    const fetchExistOwnCode = async () => {
      const getData = await helpHttp().get2(ENDPOINT,`articles/getexistowncode/`, token,formArticle.owncode.replace(/[.\-/\\|]/g, "").trim());
      if (getData.err) {
        dispatch(warningErrorAction(t('Text_InvalidCredentials')));
      } else if (isMounted) {
        setFoundOwnCode(getData!==formArticle.id && getData>0);
      }
    };
    if (showModalArticlesSettings){
      if (formArticle.owncode && formArticle.owncode.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchExistOwnCode();
      }
    }    
  }, [t,token,dispatch,i18n,formArticle.id,formArticle.owncode,showModalArticlesSettings]);

  useEffect(() => {
    let isMounted = true;
    const fetchExistCodeEan = async () => {
      const getData = await helpHttp().get2(ENDPOINT,`articles/getexistcodean/`, token,formArticle.codean.replace(/[.\-/\\|]/g, "").trim());
      if (getData.err) {
        dispatch(warningErrorAction(t('Text_InvalidCredentials')));
      } else if (isMounted) {
        setFoundCodeEan(getData!==formArticle.id && getData>0)  
      }
    };
    if (showModalArticlesSettings){
      if (formArticle.codean && formArticle.codean.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchExistCodeEan();
      }  
    }  
  }, [t,token,dispatch,i18n,formArticle.id,formArticle.codean,showModalArticlesSettings]);

  useEffect(() => {
    let isMounted = true;
    const fetchExistBarCode = async () => {
      const getData = await helpHttp().get2(ENDPOINT,`articles/getexistbarbode/`, token,formArticle.barcode.replace(/[.\-/\\|]/g, "").trim());
      if (getData.err) {
        dispatch(warningErrorAction(t('Text_InvalidCredentials')));
      } else if (isMounted) {
        setFoundBarcode(getData!==formArticle.id && getData>0); 
      }
    };
    if (showModalArticlesSettings){
      if (formArticle.barcode && formArticle.barcode.replace(/[.\-/\\|]/g, "").trim()!=="") { 
        fetchExistBarCode();
      }  
    }  
  }, [t,token,dispatch,i18n,formArticle.id,formArticle.barcode,showModalArticlesSettings]);

  const buildInitialArticle = useCallback(() => ({
    ...initialStateArticle,
    applytypesofsize: false,
    applycolor: false,
    applynumserial: false,
    isnewpiece: false,
    modifystock: true,
    salesunits_id: 1,
    department_id: 2,
    typesoftax_id: Number(DEFAULTTYPESOFTAX),
    articlestoretypesofprices: [],
    articleimages: [],
    articlesizes: [],
    articlecolors: [],
    articlestorenumseriales: []
  }), []);

  useEffect(() => {
    let isMounted = true;

    const fetchDataArticle = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get2(ENDPOINT, `articles/getarticlebyid/`, token, id);
        if (!isMounted) return;
        if (getData.err || getData.message === "Load failed") {
          setFormArticle(buildInitialArticle());
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else {
          setFormArticle(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        if (isMounted) {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }
      }
    };
    if (id !== "0") {
      fetchDataArticle();
    } else {
      setFormArticle(buildInitialArticle());
      dispatch(setLoading(false));
    }

    return () => {
      isMounted = false;
    };
  }, [id, token, dispatch, t, buildInitialArticle]);
 
  useEffect(() => {
      let isMounted = true; 
      const fetchDataMarcaVehiclesType= async () => {
          try {
              const getData = await helpHttp().get2(ENDPOINT,`articles/getmarcavehicleyypesList/`,token,
                  "-1"); 
              if (getData.err) {
                  dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                  setMarcaToSelect(getData);
              }
          } catch (error) {
              dispatch(warningErrorAction(t('Text_IncorrectData')));  
          }
      };  
      if (showModalArticlesSettings && permissions.showExtendedFilter ){
        fetchDataMarcaVehiclesType();
      }
      return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formArticle.marca,showModalArticlesSettings, permissions.showExtendedFilter]);
  
  useEffect(() => {
  let isMounted = true;

  const fetchDataTypesOfPrice = async () => {
    try {
      const getData = await helpHttp().get(
        ENDPOINT,
        i18n.language === "es"
          ? "typesofprices/typesofpricesorderbynamees"
          : "typesofprices/typesofpricesorderbynameen",
        token
      );
      if (!isMounted) return;
      if (getData.err) {
        dispatch(warningErrorAction(t("Text_InvalidCredentials")));
        return;
      }
      setFormArticle(prev => {
        if (prev.articlestoretypesofprices.length > 0) return prev;
        const pricesToAdd = getData.map((type, index) => ({
          id: 0,
          indexrowstypesofprices: index + 1,
          enablestorearticleprice: true,
          typesofprice_id: type.id,
          typesofprice_namees: type.namees,
          typesofprice_nameen: type.nameen,
          saleprice: 0,
          typesoftax_id: prev.typesoftax_id,
          typesoftax_namees: prev.typesoftax_namees,
          typesoftax_nameen: prev.typesoftax_nameen,
          typesoftax_tax: prev.typesoftax_tax,
          taxinclude: prev.typesoftax_taxinclude,
        }));
        return {
          ...prev,
          articlestoretypesofprices: pricesToAdd
        };
      });
    } catch (error) {
      if (isMounted) {
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
    }
  };

  if (id === "0" && formArticle.articlestoretypesofprices.length === 0) {
    fetchDataTypesOfPrice();
  }

  return () => {
    isMounted = false;
  };
}, [id, i18n.language, token, dispatch, t, formArticle.articlestoretypesofprices.length]);

  useEffect(() => {
    let isMounted = true;
      const fetchDataModelVehiclesType = async () => {
      try {
        const getData = await helpHttp().get5(ENDPOINT,`articles/getmodelvehicletypesList`, token,
          (formArticle.marca && formArticle.marca.replace(/[.\-/\\|]/g, "").trim()!=="")?formArticle.marca.replace(/[.\-/\\|]/g, "").trim():"-1",
          (formArticle.model && formArticle.model.replace(/[.\-/\\|]/g, "").trim()!=="")?formArticle.model.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setModelToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (showModalArticlesSettings && permissions.showExtendedFilter && formArticle.marca && formArticle.marca.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchDataModelVehiclesType();  
    }else{
      setModelToSelect(initialModelToSelect);
    }
    return () => { isMounted = false }; 
  }, [t,token,dispatch,i18n,roles,formArticle.id,formArticle.marca,formArticle.model,showModalArticlesSettings, permissions.showExtendedFilter]);

  useEffect(() => {
    let isMounted = true; 
    const fetchDataTradename = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT,`articles/getlisttradename/`,token,
        (formArticle.defaultprovider_tradename!==undefined && formArticle.defaultprovider_tradename!==null && formArticle.defaultprovider_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formArticle.defaultprovider_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setTradenameOptToSelect(getData);
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    if (permissions.showExtendedFilter){
      fetchDataTradename();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,roles,formArticle.defaultprovider_tradename, permissions.showExtendedFilter]);

  return (
       <>
        {showModalArticlesSettings ? ( 
        <div className="container-fluid formgeneral-send-wrapper">
          <Box sx={{ bgcolor: '#ffffff' ,width: '1100px'}}>
             <form onSubmit={handleCloseDataEditArticle}>  
              {/* HEADER */}
              <div className="formgeneral-card-header">
                <div className="formgeneral-header-content">
                  <div className="formgeneral-header-title2">
                    {isLoadingErrorData?
                    <i className="fas fa-solid fa-exclamation fa-2x text-danger"/>:
                    (isLoadingData?
                    <CircularProgress sx={{ color : "#f6c23e"}}/>:
                    <i className={"fas fa-regular fa-home fa text-warning"}></i>)} 
                    &nbsp;&nbsp;{i18n.language==="es"?formArticle.titlees:formArticle.titleen}
                  </div>
                  <div className="email-card-actions">
                    {!isLoadingData && (
                      <>
                        <button type="button" className="formgeneral-send-btn" onClick={handleSubmitDataEditArticle} >
                          {id==="0"?t('Button_Create'):t('Button_Update')}
                        </button>
                        <button type="button" className="formgeneral-cancel-btn" onClick={handleCloseDataEditArticle} >
                          {t('Button_Cancel')}
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
              <br/> 
              {/* FORM CARD */}
              {!isLoadingData ?
                <>
                <div className="row"> 
                  <div className="col-xl-12 mb-4"> 
                    <div className="formgeneral-card-form">
                      <div className="card-body"> 
                        <div className="row no-gutters align-items-center">
                          <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_titlees')} :</label>  
                          </div>
                          <div className="col-10 p-2">
                            <TextField
                              id="titlees" 
                              name="titlees"
                              value={formArticle.titlees}
                              inputProps ={{ style: { fontSize: '18px' }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                              label={errorsArticle.titlees != null ? t(errorsArticle.titlees) : t('PlaceHolder_Article_titlees')}
                              placeholder={t('PlaceHolder_Article_titlees')}
                              variant="standard"
                              onBlur={handleBlurDataEditArticle}
                              onChange={handleChangeDataEditArticle}
                              fullWidth
                            />
                          </div> 
                        </div>
                        <div className="row no-gutters align-items-center">
                          <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_subtitlees')} :</label>     
                          </div>
                          <div className="col-10 p-2">
                            <Textarea 
                              id="subtitlees" 
                              name="subtitlees"
                              value={formArticle.subtitlees}
                              label={errorsArticle.subtitlees!=null?t(errorsArticle.subtitlees):t('PlaceHolder_Article_subtitlees')}
                              placeholder={t('PlaceHolder_Article_subtitlees')}
                              sx={{fontSize: '18px'} }
                              variant="standard"
                              onBlur={handleBlurDataEditArticle}
                              onChange={handleChangeDataEditArticle}
                              maxRows={8}
                            />  
                          </div> 
                        </div>
                        <div className="row no-gutters align-items-center">
                          <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_owncode')} :</label>    
                          </div>
                          <div className="col-4 p-2">
                            <TextField
                              id="owncode" 
                              name="owncode"
                              value={formArticle.owncode}
                              inputProps={{ style: {  fontSize: '18px' }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                              label={errorsArticle.owncode != null ? t(errorsArticle.owncode) : t('PlaceHolder_Article_owncode')}
                              placeholder={t('PlaceHolder_Article_owncode')}
                              variant="standard"
                              onBlur={handleBlurDataEditArticle}
                              onChange={handleChangeDataEditArticle} 
                              fullWidth
                            />
                          </div>
                          <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_eancode')} :</label>
                          </div>
                          <div className="col-4 p-2">
                            <TextField
                              id="codean" 
                              name="codean"
                              value={formArticle.codean}
                              inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                              label={errorsArticle.codean != null ? t(errorsArticle.codean) : t('PlaceHolder_Article_codean')}
                              placeholder={t('PlaceHolder_Article_codean')}
                              variant="standard"
                              onBlur={handleBlurDataEditArticle}
                              onChange={handleChangeDataEditArticle} 
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="row no-gutters align-items-center">
                         <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_barcode')} :</label>
                          </div>
                          <div className="col-4 p-2">
                            <TextField
                              id="barcode" 
                              name="barcode"
                              value={formArticle.barcode}
                              inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                              label={errorsArticle.barcode != null ? t(errorsArticle.barcode) : t('PlaceHolder_Article_barcode')}
                              placeholder={t('PlaceHolder_Article_barcode')}
                              variant="standard"
                              onBlur={handleBlurDataEditArticle}
                              onChange={handleChangeDataEditArticle} 
                              fullWidth
                            />
                          </div>
                           <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Accountingcode')} :</label>
                          </div>
                          <div className="col-4 p-2">
                            <TextField
                              id="accountingcode" 
                              name="accountingcode"
                              value={formArticle.accountingcode}
                              inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                              label={errorsArticle.accountingcode != null ? t(errorsArticle.accountingcode) : t('PlaceHolder_Article_Accountingcode')}
                              placeholder={t('PlaceHolder_Article_Accountingcode')}
                              variant="standard"
                              onBlur={handleBlurDataEditArticle}
                              onChange={handleChangeDataEditArticle} 
                              fullWidth
                            />
                          </div>  
                        </div>
                        {permissions.showExtendedFilter && 
                          <>
                          <div className="row no-gutters align-items-center">
                            <div className="col-2 p-2">
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_location')} :</label>
                            </div>
                            <div className="col-4 p-2">
                              <TextField
                                id="location" 
                                name="location"
                                value={formArticle.location}
                                inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                                InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                                label={errorsArticle.location != null ? t(errorsArticle.location) : t('PlaceHolder_location')}
                                placeholder={t('PlaceHolder_location')}
                                variant="standard"
                                onBlur={handleBlurDataEditArticle}
                                onChange={handleChangeDataEditArticle} 
                                fullWidth
                              />
                            </div>
                              </div>
                          </>
                        }
                        {permissions.showExtendedFilter && 
                          <>
                            <div className="row no-gutters align-items-center">
                              <div className="col-2 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Marca')} :</label> 
                              </div>
                              <div className="col-4 p-2">
                                {/* Campo de texto para escribir y filtrar */}
                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="marca"
                                    name="marca"
                                    value={formArticle.marca}
                                    onChange={(e) => {
                                      setFormArticle(prev => ({
                                        ...prev,
                                        marca: e.target.value.toUpperCase() 
                                      }));
                                      debouncedHandleSearchMarca(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownMarca}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsArticle.marca != null
                                      ? t(errorsArticle.marca)
                                      : t('Text_Marca')}
                                    placeholder={t('PlaceHolder_Marca')}
                                    inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                                    InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' } }}
                                    variant="outlined"
                                    fullWidth
                                  />
                                  {filteredMarca.length > 0 && (
                                    <div
                                    ref={ddRefMarca}
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: '0px',
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: '18px',
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()}
                                    >
                                      {filteredMarca.map((vehicletype, index) => (
                                        <MenuItem
                                          key={vehicletype.id}
                                          onClick={() => handleSelectMarca(vehicletype)}
                                          style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor: index === highlightedIndexMarca ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexMarca ? "white" : "black",
                                          }}
                                        >
                                          {vehicletype.marca}
                                        </MenuItem>
                                      ))}
                                    </div>
                                  )} 
                                  </span> 
                              </div>
                              <div className="col-2 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Model')} :</label>
                              </div>
                              <div className="col-4 p-2">
                                {/* Campo de texto para escribir y filtrar */}
                                <span style={{ position: "relative" }} >
                                  <TextField
                                    id="model"
                                    name="model"
                                    value={formArticle.model}
                                    onChange={(e) => {
                                      setFormArticle(prev => ({
                                        ...prev,
                                        model: e.target.value.toUpperCase()
                                      }));
                                      debouncedHandleSearchModel(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownModel}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsArticle.model!=null && errorsArticle.model!==""?t(errorsArticle.model):t('Text_Model')}
                                    placeholder={t('PlaceHolder_Model')}
                                    inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    variant="outlined"
                                    fullWidth
                                  /> 
                                  {/* Desplegable dinámico */}
                                  {filteredModel.length > 0 && (
                                    <div
                                    ref={ddRefModel}
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left: '0px',
                                        border: "2px solid #4e73df",
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: '18px',
                                        backgroundColor: "#f8f9fa",
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                    {filteredModel.map((vehicle, index) => (
                                      <MenuItem
                                        key={vehicle.id}
                                        onClick={() => handleSelectModel(vehicle)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === highlightedIndexModel ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexModel ? "white" : "black",
                                        }}
                                      >
                                        {vehicle.model}
                                      </MenuItem>
                                    ))}
                                  </div>
                                  )}
                                </span> 
                              </div> 
                            </div>
                          </>
                        }
                        <div className="row no-gutters align-items-center">
                          <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_salesunits')} :</label> 
                          </div>
                          <div className="col-4 p-2">
                            <TextField
                              id="salesunits_id"
                              name="salesunits_id"
                              value={ (formArticle.salesunits_id === undefined || formArticle.salesunits_id ===null || formArticle.salesunits_id ===""
                                    || formArticle.salesunits_id ==="0" || formArticle.salesunits_id ===0)?1:formArticle.salesunits_id}
                              inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                              label={errorsArticle.salesunits_id != null ? t(errorsArticle.salesunits_id) : t('Text_salesunits')}
                              variant="outlined"
                              fullWidth
                              onBlur={handleBlurSelectSalesUnits}
                              onChange={handleChangeSelectSalesUnits}
                              select
                              SelectProps={{
                                native: true,
                                value: (formArticle.salesunits_id === undefined || formArticle.salesunits_id ===null || formArticle.salesunits_id ===""
                                    || formArticle.salesunits_id ==="0" || formArticle.salesunits_id ===0)?1: formArticle.salesunits_id
                              }}>
                              <option key={0} value=""/>
                              {salesUnitsToSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                    {i18n.language==="es"?option.namees.substring(0,80):option.nameen.substring(0,80)}
                                </option>
                              ))}
                            </TextField>
                          </div>
                          <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Department')} :</label>  
                          </div>
                          <div className="col-4 p-2">
                            <TextField
                              id="department_id"
                              name="department_id"
                              value={ (formArticle.department_id === undefined || formArticle.department_id ===null || formArticle.department_id ===""
                                    || formArticle.department_id ==="0" || formArticle.department_id ===0)?0:formArticle.department_id}
                              inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                              label={errorsArticle.department_id != null ? t(errorsArticle.department_id) : t('Text_Department')}
                              variant="outlined"
                              fullWidth
                              onBlur={handleBlurSelectDepartment}
                              onChange={handleChangeSelectDepartment}
                              select
                              SelectProps={{
                                native: true,
                                value: (formArticle.department_id === undefined || formArticle.department_id ===null || formArticle.department_id ===""
                                    || formArticle.department_id ==="0" || formArticle.department_id ===0)?0: formArticle.department_id
                              }}>
                              <option key={0} value=""/>
                              {departmentsToSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                   {i18n.language==="es"?option.code+' - '+option.namees:option.code+' - '+option.nameen} 
                                </option>
                              ))}
                            </TextField>
                          </div>
                        </div>
                        <div className="row no-gutters align-items-center">
                          <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Section')} :</label>   
                          </div>
                          <div className="col-4 p-2">
                            <TextField
                              id="section_id"
                              name="section_id"
                              value={ (formArticle.section_id === undefined || formArticle.section_id ===null || formArticle.section_id ===""
                                    || formArticle.section_id ==="0" || formArticle.section_id ===0)?0:formArticle.section_id}
                              inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                              label={errorsArticle.section_id != null ? t(errorsArticle.section_id) : t('Text_Section')}
                              variant="outlined"
                              fullWidth
                              onBlur={handleBlurSelectSection}
                              onChange={handleChangeSelectSection}
                              select
                              SelectProps={{
                                native: true,
                                value: (formArticle.section_id === undefined || formArticle.section_id ===null || formArticle.section_id ===""
                                    || formArticle.section_id ==="0" || formArticle.section_id ===0)?0: formArticle.section_id
                              }}>
                              <option key={0} value=""/>
                                {sectionsToSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                   {i18n.language==="es"?option.code+' - '+option.namees:option.code+' - '+option.nameen} 
                                </option>
                              ))}
                            </TextField>
                          </div>
                          <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Group')} :</label>    
                          </div>
                          <div className="col-4 p-2">
                             <TextField
                              id="subsection_id"
                              name="subsection_id"
                              value={ (formArticle.subsection_id === undefined || formArticle.subsection_id ===null || formArticle.subsection_id ===""
                                    || formArticle.subsection_id ==="0" || formArticle.subsection_id ===0)?0:formArticle.subsection_id}
                              inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                              label={errorsArticle.subsection_id != null ? t(errorsArticle.subsection_id) : t('Text_Group')}
                              variant="outlined"
                              fullWidth
                              onBlur={handleBlurSelectGroup}
                              onChange={handleChangeSelectGroup}
                              select
                              SelectProps={{
                                native: true,
                                value: (formArticle.subsection_id === undefined || formArticle.subsection_id ===null || formArticle.subsection_id ===""
                                    || formArticle.subsection_id ==="0" || formArticle.subsection_id ===0)?0: formArticle.subsection_id
                              }}>
                              <option key={0} value=""/>
                                {subsectionsToSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                   {i18n.language==="es"?option.code+' - '+option.namees:option.code+' - '+option.nameen} 
                                </option>
                              ))}
                            </TextField>
                          </div>
                        </div>
                        {permissions.showExtendedFilter && 
                          <>
                            <div className="row no-gutters align-items-center">
                              <div className="col-2 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Defaultprovider_Businessname')} :</label>
                              </div>
                              <div className="col-4 p-2">
                                <span style={{ position: "relative" }}>
                                  <TextField
                                      id="defaultprovider_tradename"
                                      name="defaultprovider_tradename"
                                      value={formArticle.defaultprovider_tradename}
                                      onChange={(e) => {
                                          setFormArticle(prev => ({
                                            ...prev,
                                            defaultprovider_tradename: e.target.value.toUpperCase()
                                          }));
                                          debouncedHandleSearchTradename(e.target.value);
                                      }}
                                      onKeyDown={handleKeyDownTradename}
                                      onBlur={(event) => {
                                          if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                          handleBlur();
                                          }
                                      }}
                                      label={errorsArticle.defaultprovider_tradename!=null && errorsArticle.defaultprovider_tradename!==""?t(errorsArticle.defaultprovider_tradename):t('Text_Defaultprovider_Businessname')}
                                      placeholder={t('Text_Defaultprovider_Businessname')}
                                      variant="standard"
                                      fullWidth
                                      inputProps={{ style: { fontSize: '18px', }, maxLength: 100 }}
                                      InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  />  
                                  {/* Desplegable dinámico */}
                                  {filteredTradenamed.length > 0 && (
                                      <div
                                          ref={ddRefTrade}
                                          className="dropdown-class"
                                          style={{
                                              position: "absolute",
                                              left:'0px',
                                              border: "2px solid #4e73df", // Borde azul (#4e73df)
                                              borderRadius: "4px",
                                              marginTop: "4px",
                                              maxHeight: "200px",
                                              maxWidth: "750px",
                                              overflowY: "auto",
                                              width: "150%",
                                              fontSize: '18px',
                                              backgroundColor: "#f8f9fa", // Fondo gris claro
                                              zIndex: 1000,
                                          }}
                                          onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                      >
                                          {filteredTradenamed.map((store, index) => (
                                          <MenuItem
                                              key={store.id}
                                              onClick={() => handleSelectTradeName(store)}
                                              style={{
                                                  cursor: "pointer",
                                                  padding: "8px",
                                                  borderBottom: "1px solid #eee",
                                                  fontSize: '18px',
                                                  backgroundColor:
                                                  index === highlightedIndexTradenamed ? "#4e73df" : "transparent",
                                                  color: index === highlightedIndexTradenamed ? "white" : "black",
                                              }}
                                          >
                                              {store.tradename} - {store.documentid}
                                          </MenuItem>
                                          ))}
                                      </div>
                                  )}
                                </span> 
                              </div>
                              <div className="col-2 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Lastprovider_Businessname')} :</label>
                              </div>
                              <div className="col-4 p-2">
                                <TextField
                                  id="lastprovider_tradename" 
                                  name="lastprovider_tradename"
                                  value={formArticle.lastprovider_tradename}
                                  inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                                  InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                                  label={errorsArticle.lastprovider_tradename != null ? t(errorsArticle.lastprovider_tradename) : t('PlaceHolder_Lastprovider')}
                                  placeholder={t('PlaceHolder_Lastprovider')}
                                  variant="standard"
                                  disabled
                                  fullWidth
                                /> 
                              </div>
                            </div>
                            <div className="row no-gutters align-items-center">
                            <div className="col-2 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Averagepurchaseprice')} :</label>
                              </div>
                              <div className="col-4 p-2">
                                <NumericFormat 
                                  thousandSeparator={','} 
                                  decimalSeparator={'.'} 
                                  decimalScale= {2}
                                  fixedDecimalScale= {true}
                                  allowNegative= {false}
                                  isAllowed={withValueCap}
                                  id="averagepurchaseprice" 
                                  name="averagepurchaseprice"
                                  value={formArticle.averagepurchaseprice}
                                  label={errorsArticle.averagepurchaseprice!=null?t(errorsArticle.averagepurchaseprice):t('PlaceHolder_Averagepurchaseprice')}
                                  placeholder={t('PlaceHolder_Averagepurchaseprice')}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  customInput={TextField}
                                  fullWidth
                                  disabled
                                />
                              </div> 
                            </div>
                            <div className="row no-gutters align-items-center">
                            <div className="col-2 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Lastpurchaseprice')} :</label>
                              </div>
                              <div className="col-4 p-2">
                                <NumericFormat 
                                  thousandSeparator={','} 
                                  decimalSeparator={'.'} 
                                  decimalScale= {2}
                                  fixedDecimalScale= {true}
                                  allowNegative= {false}
                                  isAllowed={withValueCap}
                                  id="lastpurchaseprice" 
                                  name="lastpurchaseprice"
                                  className="numeric-field"
                                  value={formArticle.lastpurchaseprice}
                                  label={errorsArticle.lastpurchaseprice!=null?t(errorsArticle.lastpurchaseprice):t('PlaceHolder_Lastpurchaseprice')}
                                  placeholder={t('PlaceHolder_Lastpurchaseprice')}
                                  disabled
                                />
                              </div>
                              <div className="col-2 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Datelastpurchaseprice')} :</label>
                              </div>
                              <div className="col-4 p-2">
                              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === "es" ? es : undefined}>
                                  <DesktopDatePicker
                                    id="datelastpurchaseprice" 
                                    name="datelastpurchaseprice"
                                    value={ formArticle.datelastpurchaseprice!== null ? new Date(formArticle.datelastpurchaseprice):null}
                                    format={i18n.language==="es"?"dd/MM/yyyy":"MM/dd/yyyy"}
                                    label={errorsArticle.datelastpurchaseprice!=null?t(errorsArticle.datelastpurchaseprice):t('Text_Datelastpurchaseprice')}
                                    disabled
                                    slotProps={{
                                      textField: {
                                        placeholder: i18n.language === "es" ? "dd/MM/yyyy" : "MM/dd/yyyy",
                                        sx: {
                                          maxLength: '100',
                                          width: '100%',  
                                          fontSize: '18px',  
                                        },
                                        InputProps: {
                                          style: {
                                            fontSize: '18px',
                                          }
                                        },
                                        InputLabelProps:{ 
                                          style: {
                                            fontSize: '18px', 
                                            background: '#FFFFFF'
                                          }
                                        },
                                      },
                                    }}
                                  />
                                </LocalizationProvider>
                              </div>
                            </div>
                          </>
                        }
                        <div className="row no-gutters align-items-center">
                         <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Purchasetypesoftax_Namees')} :</label>
                          </div>
                          <div className="col-4 p-2">
                            <TextField
                              id="typesoftax_id"
                              name="typesoftax_id"
                              value={ (formArticle.typesoftax_id === undefined || formArticle.typesoftax_id ===null || formArticle.typesoftax_id ===""
                                    || formArticle.typesoftax_id ==="0" || formArticle.typesoftax_id ===0)?Number(DEFAULTTYPESOFTAX):formArticle.typesoftax_id}
                              inputProps={{ style: { fontSize: '18px' }, maxLength: 100 }}
                              InputLabelProps={{ style: { fontSize: '18px', background: '#FFFFFF' }}}
                              label={errorsArticle.typesoftax_id != null ? t(errorsArticle.typesoftax_id) : t('Text_Purchasetypesoftax_Namees')}
                              variant="outlined"
                              fullWidth
                              onBlur={handleBlurSelectTypesOfTax}
                              onChange={handleChangeSelectTypesOfTax}
                              select
                              SelectProps={{
                                native: true,
                                value: (formArticle.typesoftax_id === undefined || formArticle.typesoftax_id ===null || formArticle.typesoftax_id ===""
                                    || formArticle.typesoftax_id ==="0" || formArticle.typesoftax_id ===0)?Number(DEFAULTTYPESOFTAX): formArticle.typesoftax_id
                              }}>
                              <option key={0} value=""/>
                                {typesOfTaxesToSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {i18n.language==="es"?option.namees:option.nameen}
                                </option>
                              ))}
                            </TextField>
                          </div>
                          {permissions.showExtendedFilter && 
                            <>
                              <div className="col-2 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Modifystock')} :</label>
                              </div>
                              <div className="col-4 p-2">
                                <Checkbox  
                                  style={{color:"#4e73df", fontSize: 18, paddingLeft:2}} 
                                  id="modifystock"
                                  name="modifystock"
                                  checked={formArticle.modifystock} 
                                  onChange={handleChangeModifystock} 
                                  sx={{
                                    '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                  }}
                                /> 
                              </div>
                            </>
                          }
                        </div>
                        {permissions.showExtendedFilter && 
                          <>
                            <div className="row no-gutters align-items-center">
                            <div className="col-2 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Minimumstock')} :</label>
                              </div>
                              <div className="col-4 p-2">
                                <NumericFormat 
                                  thousandSeparator={','} 
                                  decimalSeparator={'.'} 
                                  decimalScale= {2}
                                  fixedDecimalScale= {true}
                                  allowNegative= {false}
                                  isAllowed={withValueCap}
                                  id="minimumstock" 
                                  name="minimumstock"
                                  value={formArticle.minimumstock}
                                  className="numeric-field"
                                  label={errorsArticle.minimumstock!=null?t(errorsArticle.minimumstock):t('PlaceHolder_Minimumstock')}
                                  placeholder={t('PlaceHolder_Minimumstock')}
                                  onBlur={handleBlurDataEditNumber}
                                  onChange={handleChangeDataEditNumer} 
                                />
                              </div>
                              <div className="col-2 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Maximumstock')} :</label>
                              </div>
                              <div className="col-4 p-2">
                                <NumericFormat 
                                  thousandSeparator={','} 
                                  decimalSeparator={'.'} 
                                  decimalScale= {2}
                                  fixedDecimalScale= {true}
                                  allowNegative= {false}
                                  isAllowed={withValueCap}
                                  id="maximumstock" 
                                  name="maximumstock"
                                  value={formArticle.maximumstock}
                                  className="numeric-field"
                                  label={errorsArticle.maximumstock!=null?t(errorsArticle.maximumstock):t('PlaceHolder_Maximumstock')}
                                  placeholder={t('PlaceHolder_Maximumstock')}
                                  onBlur={handleBlurDataEditNumber}
                                  onChange={handleChangeDataEditNumer} 
                                />
                              </div>
                            </div>
                            <div className="row no-gutters align-items-center">
                              <div className="col-2 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Actualstock')} :</label>
                              </div>
                              <div className="col-4 p-2">
                                <NumericFormat 
                                  thousandSeparator={','} 
                                  decimalSeparator={'.'} 
                                  decimalScale= {2}
                                  fixedDecimalScale= {true}
                                  allowNegative= {true}
                                  isAllowed={withValueCap}
                                  id="actualstock" 
                                  name="actualstock"
                                  className="numeric-field"
                                  value={formArticle.actualstock}
                                  label={errorsArticle.actualstock!=null?t(errorsArticle.actualstock):t('Text_Actualstock')}
                                  placeholder={t('Text_Actualstock')}
                                  onBlur={handleBlurDataEditNumber}
                                  onChange={handleChangeDataEditNumer} 
                                /> 
                              </div>
                            </div>
                          </>
                        }
                         <div className="row no-gutters align-items-center">
                          <div className="col-2 p-2">
                            <label className={"text-primary"} style={{ fontSize: 18 }}>{t('Text_ColorArticle')} :</label>
                          </div>  
                          <div className="col-4 p-2">
                            <TextField
                              id="color_id"
                              name="color_id"
                              value={ (formArticle.color_id === undefined || formArticle.color_id ===null || formArticle.color_id ===""
                                    || formArticle.color_id ==="0" || formArticle.color_id ===0)?Number(DEFAULTCOLOR):formArticle.color_id}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              inputProps={{ style: {color:formArticle.color_codehex,fontSize: '18px'}, maxLength: 100 }}
                              variant="outlined"
                              onBlur={handleBlurSelectColor}
                              onChange={handleChangeSelectColor}
                              fullWidth
                              select
                              SelectProps={{
                                native: true,
                                value: (formArticle.color_id === undefined || formArticle.color_id ===null || formArticle.color_id ===""
                                    || formArticle.color_id ==="0" || formArticle.color_id ===0)?Number(DEFAULTCOLOR): formArticle.color_id
                              }}>
                              {colorToSelect.map((option) => (
                                <option key={option.id} value={option.id}>
                                  {option.namees}
                                </option>
                              ))}
                            </TextField> 
                          
                          </div>
                        </div> 
                        <div className="row no-gutters align-items-center">
                          <div className="col-2 p-2">
                              <label className={"text-primary"} style={{ fontSize: 18 }}>{t('Text_CodeLer')} :</label>
                            </div>  
                            <div className="col-10 p-2">
                            <TextField
                              id="codeler_id"
                              name="codeler_id"
                              value={ (formArticle.codeler_id === undefined || formArticle.codeler_id ===null || formArticle.codeler_id ===""
                                    || formArticle.codeler_id ==="0" || formArticle.codeler_id ===0)?1:formArticle.codeler_id}
                              InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              inputProps={{ style: {color:"#000000", width: 746, fontSize: '18px' }, maxLength: 100, }}
                              variant="outlined"
                              onBlur={handleBlurDataEditArticleCodeLer}
                              onChange={handleChangeDataEditArticleCodeLER}
                              select
                              SelectProps={{
                                native: true,
                                value: (formArticle.codeler_id === undefined || formArticle.codeler_id ===null || formArticle.codeler_id ===""
                                    || formArticle.codeler_id ==="0" || formArticle.codeler_id ===0)?1: formArticle.codeler_id
                              }}>
                              <option key={0} value=""/>
                              {codeLERToSelect.map((option) => (
                              <option key={option.id} value={option.id}>
                                  {option.code} - {i18n.language==="es"?option.namees.substring(0,100):option.nameen.substring(0,100)}
                              </option>
                              ))}
                            </TextField>
                            &nbsp;&nbsp;
                            <IconButton  size="small"  style={{color:"#4e73df", fontSize: 18}} onClick={copyData} >
                              <ContentCopyIcon/>
                            </IconButton>
                          </div>
                        </div> 
                       
                        {permissions.showExtendedFilter && 
                          <>
                            <div className="row no-gutters align-items-center">
                              <div className="col-3 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_typesofsize_Apply')} :</label>  
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <Checkbox  
                                  style={{color:"#4e73df", fontSize: 18, paddingLeft:2}} 
                                  id="applytypesofsize"
                                  name="applytypesofsize"
                                  checked={formArticle.applytypesofsize} 
                                  onChange={handleChangeApplyTypesOfSize} 
                                  sx={{
                                    '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                  }}
                                /> 
                              </div>
                              <div className="col-3 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_color_Apply')} :</label>  
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <Checkbox  
                                  style={{color:"#4e73df", fontSize: 18, paddingLeft:2}} 
                                  id="applycolor"
                                  name="applycolor"
                                  checked={formArticle.applycolor} 
                                  onChange={handleChangeApplyColor} 
                                  sx={{
                                    '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                  }}
                                /> 
                              </div>
                              <div className="col-3 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_numserial_Apply')} :</label>  
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <Checkbox  
                                  style={{color:"#4e73df", fontSize: 18, paddingLeft:2}} 
                                  id="applynumserial"
                                  name="applynumserial"
                                  checked={formArticle.applynumserial} 
                                  onChange={handleChangeApplyNumSerial} 
                                  sx={{
                                    '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                  }}
                                /> 
                              </div> 
                              <div className="col-3 p-2">
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_isNewPiece')} :</label>  
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <Checkbox  
                                  style={{color:"#4e73df", fontSize: 18, paddingLeft:2}} 
                                  id="isnewpiece"
                                  name="isnewpiece"
                                  checked={formArticle.isnewpiece} 
                                  onChange={handleChangeApplyNewPiece} 
                                  sx={{
                                    '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                  }}
                                /> 
                              </div> 
                            </div> 
                          </>
                        }

                        <div className="row no-gutters align-items-center">
                          <div className="col-2 p-2">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Comments')} :</label>     
                          </div>
                          <div className="col-10 p-2">
                            <Textarea 
                              id="comments" 
                              name="comments"
                              value={formArticle.comments}
                              label={errorsArticle.comments!=null?t(errorsArticle.comments):t('PlaceHolder_Comments')}
                              placeholder={t('PlaceHolder_Comments')}
                              sx={{fontSize: '18px'} }
                              variant="standard"
                              onBlur={handleBlurDataEditArticle}
                              onChange={handleChangeDataEditArticle}
                              maxRows={4}
                            />  
                          </div> 
                        </div>
                        <div className="row p-2"> 
                          <div className="form-group"> 
                            <Box sx={{ width: '100%' }}>
                              <Tabs
                                value={valueTabs}
                                onChange={handleChangeValueTabs}
                                style={{color:"#4e73df"}}
                                indicatorColor="primary"
                                variant="fullWidth"
                                aria-label="secondary tabs example">
                                {permissions.showStorePrices && <Tab value="first" label={t('Text_TypeOfPrice')} />}
                                {permissions.showExtendedFilter && permissions.showStorePrices &&  <Tab value="second" label={t('Text_Images_Article')} />}
                                {permissions.showExtendedFilter && permissions.showStoreSizes  && <Tab value="third" label={t('Text_Sizes_Article')} disabled={!formArticle.applytypesofsize} />} 
                                {permissions.showExtendedFilter && permissions.showStoreColors && <Tab value="four" label={t('Text_Colors_Article')} disabled={!formArticle.applycolor} />}  
                                {permissions.showExtendedFilter && permissions.showStoreNumSeriales && <Tab value="five" label={t('Text_NumSeriales_Article')} disabled={!formArticle.applynumserial} />}  
                                 
                              </Tabs>  
                            </Box>
                          </div>
                        </div>
                        {
                          valueTabs==="first"?
                            <div className="formdi-pending-card-flat">
                              <div className="formdi-pending-card-content">
                                <TableSortingStoresPrices 
                                  dataStoresPrices={formArticle.articlestoretypesofprices}
                                  setFormArticle={setFormArticle}
                                  numTotRegStoresPrice={formArticle.articlestoretypesofprices!==null?formArticle.articlestoretypesofprices.length:0}
                                />
                              </div>
                            </div>
                          :valueTabs==="second"?
                            <div className="formdi-pending-card-flat">
                              <div className="formdi-pending-card-content">
                                <TableSortingArticleImages
                                  roles={roles}
                                  dataArticleImage={formArticle.articleimages}
                                  setEditRowArticleImage={setEditRowArticleImage}
                                  setOpenDeleteRowArticleImage={setOpenDeleteRowArticleImage}
                                  setOpenEditNewArticleImage={setOpenEditNewArticleImage}
                                  setOpenEditRowArticleImage={setOpenEditRowArticleImage}
                                />
                                <ArticleImageCreateOrEditArticleImage 
                                  openEditRowArticleImage={openEditRowArticleImage}
                                  setOpenEditRowArticleImage={setOpenEditRowArticleImage} 
                                  openEditNewArticleImage={openEditNewArticleImage} 
                                  setOpenEditNewArticleImage={setOpenEditNewArticleImage}
                                  formArticle={formArticle}
                                  setFormArticle={setFormArticle}
                                  editRowArticleImage={editRowArticleImage}
                                  setEditRowArticleImage={setEditRowArticleImage}
                                />
                              </div>
                            </div>
                          :valueTabs==="third"?
                            formArticle.applytypesofsize &&
                              <div className="formdi-pending-card-flat">
                                <div className="formdi-pending-card-content"> 
                                  <TableSortingTypesOfSizes 
                                    dataTypesOfSizes={formArticle.articlesizes} 
                                    setFormArticle={setFormArticle}
                                    numTotRegTypesOfSize={formArticle.articlesizes!==null?formArticle.articlesizes.length:0}
                                    setOpenDeleteRowTypesOfSize={setOpenDeleteRowTypesOfSize}
                                    setOpenEditNewTypesOfSize={setOpenEditNewTypesOfSize}
                                    setOpenEditRowTypesOfSize={setOpenEditRowTypesOfSize}
                                    setEditRowTypesOfSize={setEditRowTypesOfSize}
                                    roles={roles} 
                                    typesOfSizeToSelect={typesOfSizeToSelect}
                                    formArticle={formArticle}
                                  />
                                  <ArticleCreateOrEditTypesOfSize 
                                    openEditRowTypesOfSize={openEditRowTypesOfSize}
                                    setOpenEditRowTypesOfSize={setOpenEditRowTypesOfSize} 
                                    openEditNewTypesOfSize={openEditNewTypesOfSize} 
                                    setOpenEditNewTypesOfSize={setOpenEditNewTypesOfSize}
                                    formArticle={formArticle}
                                    setFormArticle={setFormArticle}
                                    editRowTypesOfSize={editRowTypesOfSize}
                                    setEditRowTypesOfSize={setEditRowTypesOfSize}
                                    typesOfSizeToSelect={typesOfSizeToSelect}
                                  />
                              </div>
                            </div>
                          :valueTabs==="four"?
                            formArticle.applycolor &&
                            <div className="formdi-pending-card-flat">
                              <div className="formdi-pending-card-content">
                                <TableSortingColors 
                                  dataColors={formArticle.articlecolors} 
                                  setFormArticle={setFormArticle}
                                  numTotRegColor={formArticle.articlecolors.length}
                                  setOpenDeleteRowColor={setOpenDeleteRowColor}
                                  setOpenEditNewColor={setOpenEditNewColor}
                                  setOpenEditRowColor={setOpenEditRowColor}
                                  setEditRowColor={setEditRowColor}
                                  roles={roles} 
                                  colorToSelect={colorToSelect}
                                  formArticle={formArticle}
                                />
                                <ArticleCreateOrEditColor 
                                  openEditRowColor={openEditRowColor}
                                  setOpenEditRowColor={setOpenEditRowColor} 
                                  openEditNewColor={openEditNewColor} 
                                  setOpenEditNewColor={setOpenEditNewColor}
                                  formArticle={formArticle}
                                  setFormArticle={setFormArticle}
                                  editRowColor={editRowColor}
                                  setEditRowColor={setEditRowColor}
                                  colorToSelect={colorToSelect}
                                />
                              </div>
                            </div> 
                          :valueTabs==="five" &&
                            formArticle.applynumserial &&
                              <div className="formdi-pending-card-flat">
                                <div className="formdi-pending-card-content">
                                  <TableSortingStoresNumSeriales 
                                    dataStoresNumSeriales={formArticle.articlestorenumseriales} 
                                    numTotRegStoresNumSerial={formArticle.articlestorenumseriales.length}
                                    setOpenDeleteRowStoresNumSerial={setOpenDeleteRowStoresNumSerial}
                                    setOpenEditNewStoresNumSerial={setOpenEditNewStoresNumSerial}
                                    setOpenEditRowStoresNumSerial={setOpenEditRowStoresNumSerial}
                                    setEditRowStoreNumSerial={setEditRowStoreNumSerial}
                                    roles={roles}
                                    formArticle={formArticle}
                                  /> 
                                  <ArticleCreateOrEditNumSerial 
                                    openEditRowStoresNumSerial={openEditRowStoresNumSerial}
                                    setOpenEditRowStoresNumSerial={setOpenEditRowStoresNumSerial} 
                                    openEditNewStoresNumSerial={openEditNewStoresNumSerial} 
                                    setOpenEditNewStoresNumSerial={setOpenEditNewStoresNumSerial}
                                    formArticle={formArticle}
                                    setFormArticle={setFormArticle}
                                    editRowStoreNumSerial={editRowStoreNumSerial}
                                    setEditRowStoreNumSerial={setEditRowStoreNumSerial} 
                                    subStoresToSelect={subStoresToSelect}
                                    typesOfSizeToSelect={typesOfSizeToSelect}
                                    colorToSelect={colorToSelect}
                                  />
                                </div>
                              </div>
                          } 
                      </div>   
                    </div>
                  </div>
                </div>
              </>:
                <LoadingNews/> 
              }
            </form>
          </Box>
          <br/>
          <Dialog open={openDeleteRowTypesOfSize} onClose={handleCancelDeleteRowTypesOfSizes} PaperProps={{ className: "my-dialog-paper-danger" }} >
            <DialogTitle className="my-dialog-title-danger">
              {t('Text_Delete')} {editRowTypesOfSize.indexrowypesofsizes} - {i18n==='es'?editRowTypesOfSize.typeofsize_namees:editRowTypesOfSize.typeofsize_nameen}
            </DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText-danger">
                  {t("Text_Line1")}<br />
                  {t("Text_Line2")}
                </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCodeDeleteTypesOfSize"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDeleteTypesOfSize}
                    onChange={handleChangeDeleteRowTypesOfSizes}
                  />
                </DialogContent>
              <DialogActions className="my-dialog-actions">
              <Button
                onClick={handleCancelDeleteRowTypesOfSizes}
                className="my-dialog-button-cancel-danger"
              >
                {t("Button_Cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={handleCloseDeleteRowTypesOfSizes}
                className="my-dialog-button-delete"
              >
                {t("Button_Delete")}
              </Button>
            </DialogActions>
          </Dialog>
          
          <Dialog open={openDeleteRowColor} onClose={handleCancelDeleteRowColors} PaperProps={{ className: "my-dialog-paper-danger" }} >
            <DialogTitle className="my-dialog-title-danger">
              {t('Text_Delete')}  {editRowColor.indexrowcolors} - {i18n==='es'?editRowColor.color_namees:editRowColor.color_nameen}
            </DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText-danger">
                  {t("Text_Line1")}<br />
                  {t("Text_Line2")}
                </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCodeDeleteColor"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDeleteColor}
                    onChange={handleChangeDeleteRowColors}
                  />
                </DialogContent>
              <DialogActions className="my-dialog-actions">
              <Button
                onClick={handleCancelDeleteRowColors}
                className="my-dialog-button-cancel-danger"
              >
                {t("Button_Cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={handleCloseDeleteRowColors}
                className="my-dialog-button-delete"
              >
                {t("Button_Delete")}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={openDeleteRowStoresNumSerial} onClose={handleCancelDeleteRowNumSeriales} PaperProps={{ className: "my-dialog-paper-danger" }} >
            <DialogTitle className="my-dialog-title-danger">
              {t('Text_Delete')} {editRowStoreNumSerial.indexrowsnumseriales} - {editRowStoreNumSerial.store_name} - {editRowStoreNumSerial.serialnumber}
            </DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText-danger">
                  {t("Text_Line1")}<br />
                  {t("Text_Line2")}
                </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCodeDeleteNumSerial"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDeleteNumSerial}
                    onChange={handleChangeDeleteRowNumSeriales}
                  />
                </DialogContent>
              <DialogActions className="my-dialog-actions">
              <Button
                onClick={handleCancelDeleteRowNumSeriales}
                className="my-dialog-button-cancel-danger"
              >
                {t("Button_Cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={handleCloseDeleteRowNumSeriales}
                className="my-dialog-button-delete"
              >
                {t("Button_Delete")}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={openDeleteRowArticleImage} onClose={handleCancelDeleteRowArticleImage} PaperProps={{ className: "my-dialog-paper-danger" }} >
            <DialogTitle className="my-dialog-title-danger">
              {t('Text_Delete')} {editRowArticleImage.indexrowsarticleimage} -{i18n==='es'?editRowArticleImage.titlees:editRowArticleImage.titleen}
            </DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText-danger">
                  {t("Text_Line1")}<br />
                  {t("Text_Line2")}
                </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCodeDeleteArticleImage"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDeleteArticleImage}
                    onChange={handleChangeDeleteRowArticleImage}
                  />
                </DialogContent>
              <DialogActions className="my-dialog-actions">
              <Button
                onClick={handleCancelDeleteRowArticleImage}
                className="my-dialog-button-cancel-danger"
              >
                {t("Button_Cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={handleCloseDeleteRowArticleImage}
                className="my-dialog-button-delete"
              >
                {t("Button_Delete")}
              </Button>
            </DialogActions>
          </Dialog> 
        </div>
      //* End Page Content *//
    ) :  null }
  </>
  )    
}

ArticleEditOrCreate.propTypes = {
  id: PropTypes.string.isRequired,
  showModalArticlesSettings: PropTypes.bool.isRequired
};

export default ArticleEditOrCreate;